export default __webpack_public_path__ + "static/media/ultrasonic.5ef9d853.svg";